export const webApiBuildUrl = (path: string): string => {
    const isLocalMachine = typeof window === 'undefined'
    const baseUrl = isLocalMachine ? process.env.NEXT_PUBLIC_LOCALHOST_BACKEND_URL : process.env.NEXT_PUBLIC_URL
    if (baseUrl && baseUrl.includes('/test-backend')) {
        return `${baseUrl}/${path}`
    }
    return `${baseUrl}/backend/${path}`
}

export const webApi2OldBuildUrl = (path: string): string => {
    const isLocalMachine = typeof window === 'undefined'
    const baseUrl = isLocalMachine ? process.env.NEXT_PUBLIC_LOCALHOST_BACKEND_URL : process.env.NEXT_PUBLIC_URL

    return `${baseUrl}/api2/${path}`
}
